export default __webpack_public_path__ + "static/media/headerLogo.7c1476c1.svg";